import { useMutation } from '@tanstack/react-query';
import { Avatar, Dropdown, App } from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  BgColorsOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authApi } from '@/api/modules/auth';
import { useAuthStore } from '@/stores/auth';
import { ROUTE_LOGIN, ROUTE_ACCOUNT } from '@/constants/routes';
import type { AppError } from '@/types/api';

type Props = {
  onOpenSettings?: () => void;
};

export function HeaderUserMenu({ onOpenSettings }: Props) {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const { message } = App.useApp();

  const logoutMutation = useMutation({
    mutationFn: () => authApi.logout(),
    onSuccess: () => {
      logout();
      message.success('已退出登录');
      navigate(ROUTE_LOGIN, { replace: true });
    },
    onError: (err: AppError) => {
      // 即使后端登出失败也清掉本地态
      logout();
      navigate(ROUTE_LOGIN, { replace: true });
      message.warning(err.message || '已退出登录');
    },
  });

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'account',
            icon: <SettingOutlined />,
            label: '个人中心',
            onClick: () => navigate(ROUTE_ACCOUNT),
          },
          {
            key: 'theme',
            icon: <BgColorsOutlined />,
            label: '主题设置',
            onClick: () => onOpenSettings?.(),
          },
          { type: 'divider' as const },
          {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: '退出登录',
            onClick: () => logoutMutation.mutate(),
          },
        ],
      }}
      placement="bottomRight"
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
        <Avatar icon={<UserOutlined />} src={user?.avatar_url ?? undefined} />
        <span style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: 1.3 }}>
          <span style={{ fontSize: 14 }}>{user?.name ?? '未登录'}</span>
          {user?.employee_no && (
            <span style={{ fontSize: 11, color: '#999' }}>{user.employee_no}</span>
          )}
        </span>
      </span>
    </Dropdown>
  );
}
